export default __webpack_public_path__ + "static/media/house.09e3df6f.gif";